import {AppBar, IconButton, Link, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar} from "@mui/material";
import {Call, Edit, Home, Info, Menu as MenuIcon} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import route from "../../../../enum/route";
import useInterventionRepository from "../../../../repository/insurance/useInterventionRepository";
import useClientRepository from "../../../../repository/insurance/useClientRepository";
import InterventionUtils from "../../../../entity/utils/insurance/InterventionUtils";
import Intervention from "../../../../entity/insurance/Intervention";
import isNull from "../../../../mixin/isNull";

export default function ({orderId, interventionId, clientId, onUpdateQuotation, updateQuotation, onOpenOrderData}) {
    const navigate = useNavigate();
    const interventionRepository = useInterventionRepository();
    const clientRepository = useClientRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        clientRepository.findOneById(clientId).exec();
    }, []);

    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleHome = () => {
        navigate(route.ENTREPRENEUR_INTERVENTIONS);
        handleClose();
    }

    const handleOpenOrderData = () => {
        onOpenOrderData();
        handleClose();
    }

    const handleUpdateQuotation = () => {
        onUpdateQuotation();
        handleClose();
    }

    if (isNull(intervention)) return null;

    return (
        <AppBar position="sticky" sx={{top: 0}}>
            <Toolbar>
                <Typography
                    component="div"
                    sx={{flexGrow: 1, textTransform: "uppercase"}}
                    fontWeight={"bold"}
                    data-test="insurance-header-text"
                >
                    Dossier {orderId}
                    <Typography fontSize="small">
                        {
                            updateQuotation
                                ? "Modification du devis"
                                : InterventionUtils.getCurrentStepAsTextForCompany(intervention.getCurrentStep())
                        }
                    </Typography>
                </Typography>
                <div>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                        data-test="insurance-button-menu"
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {
                            intervention.getCurrentStep() > Intervention.STEP_INITIALIZED
                                ? (
                                    <MenuItem onClick={handleClose} data-test="insurance-menu-call-beneficiary">
                                        <ListItemIcon>
                                            <Call/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Link
                                                href={`tel:${client?.getPhoneMobile()}`}
                                                sx={{textDecoration: "none", color: "inherit"}}
                                            >
                                                Appeler le sociétaire
                                            </Link>
                                        </ListItemText>
                                    </MenuItem>
                                )
                                : null
                        }
                        <MenuItem onClick={handleClose}>
                            <ListItemIcon>
                                <Call/>
                            </ListItemIcon>
                            <ListItemText>
                                <Link
                                    href={`tel:${process.env.REACT_APP_FFG_PHONE_NUMBER}`}
                                    sx={{textDecoration: "none", color: "inherit"}}
                                >
                                    Nous contacter
                                </Link>
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleOpenOrderData}>
                            <ListItemIcon>
                                <Info/>
                            </ListItemIcon>
                            <ListItemText>
                                Info dossier
                            </ListItemText>
                        </MenuItem>
                        {
                            intervention.getCurrentStep() >= Intervention.STEP_PICTURE_BEFORE &&
                            intervention.getCurrentStep() <= Intervention.STEP_WORKS
                                ? (
                                    <MenuItem
                                        onClick={handleUpdateQuotation}
                                        data-test="insurance-menu-edit-quotation"
                                    >
                                        <ListItemIcon>
                                            <Edit/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            Modifier mon devis
                                        </ListItemText>
                                    </MenuItem>
                                )
                                : null
                        }
                        <MenuItem onClick={handleHome} data-test="insurance-menu-back">
                            <ListItemIcon>
                                <Home/>
                            </ListItemIcon>
                            <ListItemText>
                                Revenir à l'accueil
                            </ListItemText>
                        </MenuItem>
                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    );
}
